export default __webpack_public_path__ + "static/media/GRES.acaefe4b.png";